export function BrandMark({ className = "h-9 w-9", animate = false }) {
  return (
    <img
      src="/logo-a.png"
      alt="EverMind"
      data-testid="brand-logo"
      className={`rounded-full object-cover ${animate ? "animate-breathe" : ""} ${className}`}
    />
  );
}
